<nav
  [ngClass]="themeClass"
  [class]="navClass + ' navbar navbar-expand-lg bg-body-tertiary'"
>
  <div class="container-fluid topbar-public__container">
    <a class="navbar-brand topbar-public__brand" href="#">
      <img
        src="./assets/img/logo-geo.png"
        alt=""
        class="topbar-public__logo"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      [attr.data-bs-target]="'#' + collapseId"
      [attr.aria-controls]="collapseId"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse topbar-public__collapse"
      [id]="collapseId"
    >
      <ul class="navbar-nav ms-auto topbar-public__nav">
        <li
          *ngFor="let item of menuItems"
          class="nav-item"
          [class.dropdown]="item.submenu.length != 0"
        >
          <a
            *ngIf="item.codigo == 2"
            class="nav-link active topbar-public__link"
            aria-current="page"
            [href]="item.ruta"
            (click)="onGeoBosquesClick()"
            >{{ item.descripcion }}</a
          >
          <a
            *ngIf="item.submenu.length == 0 && item.codigo != 2"
            class="nav-link active"
            aria-current="page"
            [href]="item.ruta"
            >{{ item.descripcion }}</a
          >
          <a
            *ngIf="item.submenu.length != 0 && item.codigo != 2"
            class="nav-link dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ item.descripcion }}
          </a>
          <ul
            *ngIf="item.submenu.length != 0 && item.codigo != 2"
            class="dropdown-menu topbar-public__dropdown"
            data-bs-display="static"
          >
            <li *ngFor="let subitem of item.submenu">
              <a class="dropdown-item" [href]="subitem.url">{{
                subitem.descripcion
              }}</a>
            </li>
          </ul>
        </li>
        <li class="nav-item dropdown topbar-public__account-item">
          <a
            class="nav-link dropdown-toggle d-flex align-items-center gap-2 topbar-public__account-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span *ngIf="isAuthenticate" class="topbar-public__account-name">{{
              nameMenu
            }}</span>
            <img
              src="./assets/img/cuenta.png"
              alt=""
              class="topbar-public__account-avatar"
            />
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end topbar-public__dropdown topbar-public__dropdown--account"
            data-bs-display="static"
          >
            <li class="p-3" *ngIf="!isAuthenticate">
              <span
                >Inicia sesión para recibir alertas tempranas de pérdida de
                bosques</span
              >
              <div class="d-flex justify-content-center mt-4">
                <a
                  (click)="onLoginClick()"
                  class="btn btn-sm btn-success w-100"
                  >Iniciar sesión</a
                >
              </div>
            </li>
            <li *ngIf="isAuthenticate">
              <a class="dropdown-item" href="mi-cuenta">Mi cuenta</a>
            </li>
            <li *ngIf="isAuthenticate">
              <a class="dropdown-item" href="#" (click)="onLogoutClick()"
                >Cerrar sesión</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
